"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreQOpChart = void 0;
const useDimensions_1 = __importDefault(require("@opsbase/react-hooks/useDimensions"));
const Bar3DStacked_1 = __importDefault(require("@opsbase/web-charts/Bar3DStacked"));
const Table3D_1 = require("@opsbase/web-charts/Table3D");
const react_1 = __importStar(require("react"));
const ChartPane_1 = __importDefault(require("../ChartPane"));
const useScoreQOpData_1 = __importDefault(require("./useScoreQOpData"));
function ScoreQOpChart({ chart, width, height, fontSize, highlightYId, onClickValue, }) {
    const { data, loading, drawTable } = (0, useScoreQOpData_1.default)(chart.config.inverse, chart.config.pageOffset);
    const [paneRef, paneDims] = (0, useDimensions_1.default)();
    const onClickDatum = (0, react_1.useCallback)((e, v) => {
        const d = v.datum;
        onClickValue({ v: d.y, x: d.xDim, y: d.yDim });
    }, [onClickValue]);
    const chartBit = (0, react_1.useMemo)(() => {
        var _a;
        if (loading || !data || !data.length || !paneDims)
            return null;
        const chartData = data
            .map(d => (!highlightYId || d[0].yDim.id === highlightYId ? d : null))
            .filter(d => !!d);
        const xLabels = ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.map(d => (d.xDim.label + '').split(' - ').join('\n'))) || [];
        let chartProps = Object.assign({ width: paneDims.width, height: paneDims.height, fontSize, data: chartData, domain: { y: [0, 100] }, xLabels, conditionalFormating: {
                bad: chart.config.inverse ? 100 : 0,
                good: !chart.config.inverse ? 0 : 100,
            } }, (onClickValue ? { onClickDatum } : {}));
        return drawTable ? (react_1.default.createElement(Table3D_1.Table3D, Object.assign({ ySuffix: "%" }, chartProps))) : (react_1.default.createElement(Bar3DStacked_1.default, Object.assign({ ySuffix: "%" }, chartProps)));
    }, [
        loading,
        data,
        paneDims,
        fontSize,
        chart.config.inverse,
        onClickValue,
        onClickDatum,
        drawTable,
        highlightYId,
    ]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(ChartPane_1.default, { ref: paneRef, loading: loading, width: width, height: height }, chartBit)), [paneRef, loading, width, height, chartBit]);
}
exports.ScoreQOpChart = ScoreQOpChart;
exports.default = ScoreQOpChart;
